import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import {PhotoDetailsComponent} from './photo-details/photo-details.component';
import {PhotoReviewComponent} from './photo-review/photo-review.component';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {CoreModule} from '../../core/core.module';
import {SharedModule} from '../../shared/shared.module';
import {PhotoRoutingModule} from './photo-routing.module';
import {CommentComponent} from './photo-comment/comment/comment.component';
import {CommentReplyComponent} from './photo-comment/comment-reply/comment-reply.component';
import {PhotoEditComponent} from './photo-edit/edit.component';
import {ReviewSectionComponent} from './photo-review/review-section/review-section.component';
import {PreviewSectionComponent} from './photo-review/preview-section/preview-section.component';
import { PhotoInformationComponent } from './photo-information/photo-information.component';
import {HTTP_INTERCEPTORS} from "@angular/common/http";
import {AuthCamerallaInterceptor} from "../../auth/interceptors/auth.interceptor";
import {ErrorCamerallaInterceptor} from "../../auth/interceptors/error.interceptor";
import {UploadModule} from "../upload/upload.module";
import { MoveLocationForm } from "./move-location-form/move-location-form";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        CoreModule,
        SharedModule,
        PhotoRoutingModule,
        UploadModule
    ],
    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthCamerallaInterceptor,
            multi: true
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: ErrorCamerallaInterceptor,
            multi: true
        }
    ],
    declarations: [PhotoDetailsComponent, PhotoReviewComponent, PhotoEditComponent,
        CommentComponent, CommentReplyComponent, ReviewSectionComponent,
        PreviewSectionComponent, PhotoInformationComponent, MoveLocationForm],
    exports: [PhotoReviewComponent, PhotoEditComponent],
    entryComponents: [PhotoReviewComponent, PhotoEditComponent, CommentReplyComponent, MoveLocationForm],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class PhotoModule {
}
